import ResetPasswordFormView from "./ResetPasswordFormView.react"

export const content = { ResetPasswordFormView }
export default content
